// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","landingCard":"landing_landingCard__mhxBf"};